import React, { useEffect, useState } from 'react'
import Topbar from '../../Components/Topbar'
import LeftbarUser from '../../Components/LeftbarUser'
import BottomNavUser from '../../Components/BottomNavUser'
import { useNavigate, useParams } from 'react-router-dom'
import { getFirestore, doc, getDoc } from 'firebase/firestore'
import { app } from '../../firebase'
import Spinner from 'react-bootstrap/Spinner';
import youtubeIcon from '../../Images/youtube.png'
import instagramIcon from '../../Images/instagram2.png'
import tiktokIcon from '../../Images/tiktok.png'
import twitterIcon from '../../Images/Twitter.svg'
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Button } from 'react-bootstrap'
import swal from 'sweetalert';
import { ToastContainer, toast, Bounce } from 'react-toastify';
import { getStorage, ref as storageRef, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";

function UserSubscribe() {
    const { id } = useParams()
    const db = getFirestore(app)


    const [loading, setLoading] = useState(true)
    const [data, setData] = useState(null)
    const [makePaymentBtn, setMakePaymentBtn] = useState(true)
    const [loadingBtn, setLoadingBtn] = useState(false)
    const navigate = useNavigate()
    const [loggedInUserId, setloggedInUserId] = useState();
    const [loggedInUserName, setloggedInUserName] = useState();

    const [loggedInPhoneNumber, setloggedInPhoneNumber] = useState();
    const [loggedInEmail, setloggedInEmail] = useState();

    const [influencerPhoneNumber, setinfluencerPhoneNumber] = useState();
    const [influencerEmail, setinfluencerEmail] = useState();


    const auth = getAuth()

    const [adPurpose, setAdPurpose] = useState('');
    const [businessCategory, setBusinessCategory] = useState('');
    const [brandName, setBrandName] = useState('');
    const [businessDesc, setBusinessDesc] = useState('');
    const [websiteLink, setWebsiteLink] = useState('');
    const [infadsNotAccepted, setinfadsNotAccepted] = useState([]);
    const [cgcDetails, setCgcDetails] = useState('')
    const [months, setMonths] = useState(1)

    useEffect(() => {
        document.title = "Zindua App | Dashboard";

        // Meta description
        let desc = document.querySelector("meta[name='description']");
        if (!desc) {
            desc = document.createElement("meta");
            desc.setAttribute("name", "description");
            document.head.appendChild(desc);
        }
        desc.setAttribute("content", "Zindua App dashboard");

        // Open Graph tags
        const ogTags = [
            { property: "og:title", content: "Zindua App | Dashboard" },
            { property: "og:description", content: "Zindua App Dashboard" },
            { property: "og:type", content: "website" },
            { property: "og:url", content: "https://zindua.app/dashboard" },
            { property: "og:image", content: "https://zindua.app/logo192.png" },
        ];

        ogTags.forEach(({ property, content }) => {
            let tag = document.querySelector(`meta[property='${property}']`);
            if (!tag) {
                tag = document.createElement("meta");
                tag.setAttribute("property", property);
                document.head.appendChild(tag);
            }
            tag.setAttribute("content", content);
        });

        // JSON-LD structured data
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.text = JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Zindua App Influencer Dashboard",
            "url": "https://zindua.app/dashboard",
            "description": "Zindua App influencer dashboard where you can manage your earnings, running ads, subscriptions, and withdraw funds to M-Pesa.",
            "inLanguage": "en",
            "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://zindua.app/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Dashboard",
                        "item": "https://zindua.app/dashboard"
                    }
                ]
            }
        });
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);

    useEffect(() => {
        const fetchInfluencer = async () => {
            const ref = doc(db, "users", id)
            const snap = await getDoc(ref)
            if (snap.exists()) {
                setData(snap.data())
                setinfadsNotAccepted(snap.data().adsNotAccepted);

                setinfluencerPhoneNumber(snap.data().mpesaNumber)
                setinfluencerEmail(snap.data().email)

            }
            setLoading(false) //
        }
        fetchInfluencer()
    }, [id])

    //who is logged in
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            const uid = user.uid
            const docRef = doc(db, "users", uid)
            const snap = await getDoc(docRef)
            setloggedInUserId(uid)

            if (snap.exists()) {
                const data = snap.data()
                const freshName = data.userName || ""
                setloggedInUserName(freshName)
                setloggedInPhoneNumber(data.mpesaNumber)
                setloggedInEmail(data.email)
            }
        })

        return () => unsubscribe()
    }, [])

    const [showPaymentModal, setShowPaymentModal] = useState(false)
    const [mpesaNumber, setMpesaNumber] = useState("")
    const baseUrl = 'https://us-central1-zindua-ke.cloudfunctions.net/paymentApi';

    /* ================= PAYMENT LOGIC ================= */
    // PAYMENT STATES
    const [paymentTransactionId, setPaymentTransactionId] = useState(null)
    const [paymentCountdown, setPaymentCountdown] = useState(0)
    const [isPaymentProcessing, setIsPaymentProcessing] = useState(false)

    const startCountdown = () => {
        setPaymentCountdown(180)
        const interval = setInterval(() => {
            setPaymentCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(interval)
                    toast.error("Payment timed out. Retrying STK push...")
                    retryPayment(paymentTransactionId)
                    return 0
                }
                return prev - 1
            })
        }, 1000)
    }

    const retryPayment = async transactionId => {
        if (transactionId) await verifyPayment(transactionId)
    }

    const makePayment = async () => {
        if (!validateBeforePayment()) return
        if (!mpesaNumber) {
            swal("Error", "Please enter your MPESA number", "error")
            return
        }

        setShowPaymentModal(true)
        setIsPaymentProcessing(true)
        setMakePaymentBtn(false)
        setLoadingBtn(true)

        try {
            const totalCost = data.subscriptionPrice * months || 1
            const payload = {
                amount: totalCost,
                contact_phone_number: mpesaNumber,
                contact_name: loggedInUserName,
                description: `Subscription to ${data.userName}`
            }

            const res = await fetch(`${baseUrl}/make-payment`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            })

            if (!res.ok) throw new Error("Payment request failed")

            const resData = await res.json()
            const transactionId = resData?.data?.data?.transaction?.id
            setPaymentTransactionId(transactionId)

            toast.success("Payment request sent. Check your phone for STK prompt.")
            startCountdown()
            await verifyPayment(transactionId)

        } catch (err) {
            console.error("Payment error:", err)
            toast.error("Failed to initiate payment. Retrying...")
            setTimeout(() => makePayment(), 3000)
        }
    }

    const verifyPayment = async transactionId => {
        try {
            const res = await fetch(`${baseUrl}/verify-payment/${transactionId}`)
            const dataRes = await res.json()
            const tx = dataRes?.data?.data?.transaction?.[0]

            if (!tx || tx.status === "pending") {
                setTimeout(() => verifyPayment(transactionId), 5000)
                return
            }

            if (tx.status === "success") {
                setIsPaymentProcessing(false)
                setShowPaymentModal(false)
                processPayment("Mpesa Choice Bank", "KES", transactionId, "success")
                toast.success("Payment successful!")
            } else {
                setIsPaymentProcessing(false)
                setShowPaymentModal(false)
                swal("Payment failed", `Status: ${tx.status}`, "error")
            }

        } catch (err) {
            console.error("Verification error:", err)
            setTimeout(() => verifyPayment(transactionId), 5000)
        }
    }



    const validateBeforePayment = () => {
        // Check required fields
        if (!adPurpose || !businessCategory || !brandName || !businessDesc || !websiteLink || !cgcDetails) {
            swal("Error", "Please fill all required fields before proceeding to payment", "error");
            return false;
        }

        //check the ads the influencer doesnt accept here 
        if (infadsNotAccepted?.[businessCategory] === true) {
            swal("Error", `The influencer does not accept ads for ${businessCategory}. Please pick a different category.`, "error");
            return false;
        }

        return true; // All validations passed
    };



    async function processPayment(payMethod, currency, responseReference, responseTrans) {
        toast.info("Submitting your subscription, please wait...");
        setLoadingBtn(true);

        try {
            const db = getFirestore(app);

            // const thirtyDays = 30 * 24 * 60 * 60 * 1000;
            // const expiryDate = Timestamp.fromDate(new Date(Date.now() + thirtyDays));

            const days = months * 30
            const expiryDate = Timestamp.fromDate(
                new Date(Date.now() + days * 24 * 60 * 60 * 1000)
            )
            const totalCost = data.subscriptionPrice * months

            const subsPayload = {
                influencerId: id,
                cgcDetails,
                businessCategory,
                brandName,
                businessDesc,
                websiteLink,
                adPurpose,
                loggedInUserId,
                mpesaNumber,
                payMethod,
                currency,
                paymentReference: responseReference,
                paymentStatus: responseTrans,
                subsStatus: "subscribed",
                timestamp: Timestamp.now(),
                expiryDate,
                totalCost,
                months
            };


            // Save to Firestore
            const adRef = await addDoc(collection(db, "subscriptions"), subsPayload);
            const adID = adRef.id
            await addIncome(payMethod, currency, responseReference, responseTrans, data.subscriptionPrice, mpesaNumber, adID);


        } catch (error) {
            setMakePaymentBtn(true);
            setLoadingBtn(false);
            swal("Error", "Something went wrong while saving your subscription", "error");
        }
    }

    async function addIncome(payMethod, currency, responseReference, responseTrans, totalCost, mpesaNumber, adID) {
        const db = getFirestore(app);

        const incomePayload = {
            influencerId: id,
            totalCost: parseInt(totalCost),
            mpesaNumber,
            payMethod,
            currency,
            paymentReference: responseReference,
            paymentStatus: responseTrans,
            loggedInUserId,
            adStatus: "Requested",
            incomeType: "subscription",
            payoutStatus: "Pending",
            payout: parseInt(totalCost),
            timestamp: Timestamp.now(),
            adID
        };

        await addDoc(collection(db, "income"), incomePayload);

        await notify(
            influencerPhoneNumber,
            influencerEmail,
            "NEW SUBSCRIPTION",
            `You have a new ${months} month subscription from ${loggedInUserName}. Send periodic reports to the subscriber and keep them engaged`
        );

        await notify(
            loggedInPhoneNumber,
            loggedInEmail,
            "NEW SUBSCRIPTION",
            `Subscription successful. You subscribed to ${data.userName} for ${months} months. Check your messages tab for periodic reports from the Influencer`
        );

        toast.success("Subscribed successfully!");
        setMakePaymentBtn(true);
        setLoadingBtn(false);

        swal({
            title: "Success",
            text: "Subscribed successfully.",
            icon: "success"
        }).then(() => {
            navigate("/user/ads");
        });
    }

    const notify = async (phone, email, subject, message) => {
        try {
            const token = await auth.currentUser.getIdToken();

            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            };

            // Send SMS if phone is provided
            if (phone) {
                await fetch(
                    "https://us-central1-zindua-ke.cloudfunctions.net/commapi/send-sms",
                    {
                        method: "POST",
                        headers,
                        body: JSON.stringify({
                            phoneNumber: phone,
                            message,
                        }),
                    }
                );
            }

            // Send Email if email is provided
            if (email) {
                await fetch(
                    "https://us-central1-zindua-ke.cloudfunctions.net/commapi/send-email",
                    {
                        method: "POST",
                        headers,
                        body: JSON.stringify({
                            email,
                            subject,
                            message,
                        }),
                    }
                );
            }
        } catch (error) {
            console.error("Notification error:", error);
            throw error;
        }
    };








    return (
        <div className="mainDashboard">
            <div className="desktopOnly">
                <LeftbarUser />
            </div>

            <div className="mainContent">
                <Topbar />
                <section>
                    <div className="alertCont">
                        {loading && <p>Loading...</p>}

                        {!loading && data && (
                            <>
                                <h6>Monthly Subsciption</h6>
                                <p>Subscribe to <span className='getstartedSpan1'>{data.userName}</span></p>
                                <p>At KES. {data.subscriptionPrice ? Number(data.subscriptionPrice).toLocaleString() : 0} per month (30 day cycle)</p>
                                <p>The creator will do weekly reports</p>
                            </>
                        )}
                    </div>

                    <br />
                    <div>

                        <div className="adDetails container mt-3" >
                            <div className="row mb-2">

                                <div className="col-md-4">
                                    <label className="form-label">Purpose of the Subscription</label>
                                    <select className="form-select" value={adPurpose} onChange={e => setAdPurpose(e.target.value)}>
                                        <option value="">Select objective</option>
                                        <option value="Drive Sales to my business">Drive Sales to your business</option>
                                        <option value="Introduce a product/Brand">Introduce a product/Brand</option>
                                        <option value="Creating awareness">Creating awareness</option>
                                        <option value="Brand positioning">Brand positioning</option>
                                        <option value="App Installs">App Installs</option>
                                        <option value="Website Visits">Website Visits</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">Business/Service Category</label>
                                    <select className="form-select" value={businessCategory} onChange={e => setBusinessCategory(e.target.value)}>
                                        <option value="">Select Category</option>
                                        <option value="Agriculture">Agriculture</option>
                                        <option value="alcohol">Alcohol and Tobacco</option>
                                        <option value="Automotive">Automotive</option>
                                        <option value="Beauty and Sanitation">Beauty and Sanitation</option>
                                        <option value="Chemical">Chemical</option>
                                        <option value="Construction">Construction</option>
                                        <option value="Education">Education</option>
                                        <option value="Electronics Manufacturing">Electronics Manufacturing</option>
                                        <option value="Electronics Retail">Electronics Retail</option>
                                        <option value="Entertainment">Entertainment</option>
                                        <option value="Events">Events</option>
                                        <option value="Fashion and Beauty">Fashion and Beauty</option>
                                        <option value="Finance">Finance</option>
                                        <option value="Financial Services">Financial Services</option>
                                        <option value="Food and Beverage">Food and Beverage</option>
                                        <option value="Forestry, Wood, Pulp and Paper">Forestry, Wood, Pulp and Paper</option>
                                        <option value="Forex, Cryptocurrency and Stocks">Forex, Cryptocurrency and Stocks</option>
                                        <option value="General Retail and Commerce">General Retail and Commerce</option>
                                        <option value="Government Agency">Government Agency</option>
                                        <option value="gambling">Gambling</option>
                                        <option value="Health and Fitness">Health and Fitness</option>
                                        <option value="Health Care and Social Assistance">Health Care and Social Assistance</option>
                                        <option value="Hotels, Tourism, Food and Catering">Hotels, Tourism, Food and Catering</option>
                                        <option value="Information Technology">Information Technology</option>
                                        <option value="Insurance">Insurance</option>
                                        <option value="Manufacturing">Manufacturing</option>
                                        <option value="Mechanical and Electrical Engineering">Mechanical and Electrical Engineering</option>
                                        <option value="Media">Media</option>
                                        <option value="Media and News">Media and News</option>
                                        <option value="Mining">Mining</option>
                                        <option value="Music Industry">Music Industry</option>
                                        <option value="NGO or Community">NGO or Community</option>
                                        <option value="Oil and Gas">Oil and Gas</option>
                                        <option value="Online Trade">Online Trade</option>
                                        <option value="political">Politics / Political / Politician</option>
                                        <option value="Postal and Telecommunications">Postal and Telecommunications</option>
                                        <option value="Professional Services">Professional Services</option>
                                        <option value="Professional, Scientific and Technical Services">
                                            Professional, Scientific and Technical Services
                                        </option>
                                        <option value="Public Service">Public Service</option>
                                        <option value="religious">Religion</option>
                                        <option value="Real Estate">Real Estate</option>
                                        <option value="Retail">Retail</option>
                                        <option value="socialIssues">Social Issues</option>
                                        <option value="Technology">Technology</option>
                                        <option value="Textiles, Clothing, Leather and Footwear">
                                            Textiles, Clothing, Leather and Footwear
                                        </option>
                                        <option value="Transport and Warehousing">Transport and Warehousing</option>
                                        <option value="Travel">Travel</option>
                                        <option value="Utilities">Utilities</option>
                                        <option value="Wholesale Trade">Wholesale Trade</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">Business/Brand name</label>
                                    <input type="text" className="form-control" placeholder="Brand Name" value={brandName} onChange={e => setBrandName(e.target.value)} />
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-6">
                                    <label className="form-label">What does the brand/business or service do</label>
                                    <input type="text" className="form-control" placeholder="What the business or brand does" value={businessDesc} onChange={e => setBusinessDesc(e.target.value)} />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Paste your Website or social media link</label>
                                    <input type="text" className="form-control" placeholder="Paste your link" value={websiteLink} onChange={e => setWebsiteLink(e.target.value)} />
                                </div>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Give the influencer enough details to understand your objectives, goals etc</label>
                                <textarea
                                    className="form-control"
                                    rows={4}
                                    value={cgcDetails}
                                    onChange={e => setCgcDetails(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Select number of months you want to subscribe to</label>
                                <select
                                    className="form-select"
                                    value={months}
                                    onChange={e => setMonths(Number(e.target.value))}>
                                    <option value={1}>1 Month</option>
                                </select>
                            </div>



                            {data && (
                                <p>
                                    At KES {Number(data.subscriptionPrice).toLocaleString()} per month
                                    {" "}Total KES {Number(data.subscriptionPrice * months).toLocaleString()}
                                </p>
                            )}



                            {makePaymentBtn &&
                                <Button
                                    variant="success"
                                    onClick={() => {
                                        if (validateBeforePayment()) {
                                            setShowPaymentModal(true);
                                        }
                                    }}
                                >
                                    Subscribe
                                </Button>

                            }
                            {loadingBtn && <Button variant="success" disabled className='btnLogin'>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                {" "}Subscribe...
                            </Button>
                            }


                        </div>

                    </div>


                </section>

            </div >

            <div className="mobileOnly">
                <BottomNavUser />
            </div>


            <div className={`modal fade ${showPaymentModal ? "show" : ""}`} style={{ display: showPaymentModal ? "block" : "none", background: "rgba(0,0,0,0.5)" }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content" style={{ borderRadius: "12px" }}>
                        <div className="modal-header">
                            <h5 className="modal-title">Complete Payment</h5>
                            <button type="button" className="btn-close" onClick={() => setShowPaymentModal(false)}></button>
                        </div>

                        <div className="modal-body">
                            <p>Enter your M-PESA number to receive a payment prompt</p>
                            <input type="number" className="form-control" placeholder="07XX XXX XXX" value={mpesaNumber} onChange={e => setMpesaNumber(e.target.value)} />
                        </div>

                        <div className="modal-footer">
                            <Button variant="secondary" onClick={() => setShowPaymentModal(false)}>Cancel</Button>
                            <Button variant="success" onClick={() => { setShowPaymentModal(false); makePayment(); }}>Confirm and Pay</Button>
                        </div>
                    </div>
                </div>
            </div>


            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
                transition={Bounce}
            />
        </div >
    )
}

export default UserSubscribe